import React from 'react';
import InputGroup from '../../InputGroup';

import { Field } from 'redux-form';

const CvvInput = () => (
    <Field
        name="cvv"
        placeholder="CVV"
        component={InputGroup}
        type="tel"
        label="cvv"
        maxLength={4}
        autocomplete="cc-csc"
    />
);

export default CvvInput;



// WEBPACK FOOTER //
// ./src/components/Donation/Form/CvvInput.jsx